import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface PaymentEligibleUserState {
    isEligible: boolean | null;
}

export const initialState: PaymentEligibleUserState = {
    isEligible: null,
};

export const paymentEligibleUsersStateSlice = createSlice({
    name: "paymentEligibleUsersState",
    initialState,
    reducers: {
        setGlobalPaymentEligibleUser: (
            state,
            data: PayloadAction<boolean>,
        ) => {
            state.isEligible = data.payload;
            return state;
        },
        resetPaymentEligibleUsers: () => {
            return initialState;
        },
    },
});
export const { setGlobalPaymentEligibleUser, resetPaymentEligibleUsers } =
    paymentEligibleUsersStateSlice.actions;
